//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import { publishAppPermissions, infoToastPublish, decodeUnicodeEscapes } from "@/assets/js/appFunc";
import AQList from "@/components/Generics/AQList/AQList.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import UserInterfaces from "@/pages/main/views/UserInterfaces/UserInterfaces.vue";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import { getRawInterfaceModel } from "@/store/modules/components/actions";
import { uid } from "quasar";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";

const updateData = (oldData, generateUID) => {
    const { interfaceJson } = JSON.parse(oldData);
    const { components } = interfaceJson;
    let newData = oldData;

    Object.keys(components || {}).forEach(key => {
        newData = newData.replaceAll(key, generateUID());
    });

    return newData;
};

const createCode = (importFile, totalInterfaces) => {
    const nameImportFile = importFile.code.split("_")[0];
    let codeInterface = null;
    let counter = 0;

    totalInterfaces.forEach(element => {
        const elementName = element.code.split("_")[0];
        const elementCode = Number(element.code.split("_")[1]);
        if (nameImportFile === elementName) {
            if (elementCode >= counter) {
                counter = elementCode + 1;
            }
        }
    });

    codeInterface = `${nameImportFile}_${counter}`;
    return codeInterface;
};

export default {
    name: "UserInterfacesStart",
    components: { AQEmptySearch, AQEmptyState, AQSearch, AQButton, UserInterfaces, AQList, AQInput, AQDialog, AQModal, AQHistory },
    data() {
        return {
            selectedTab: "uis",
            list: {
                uis: [],
                fragments: []
            },
            optionsMore: [{ name: "rename", label: this.$tc("documents.rename") }],
            hideListBtns: ["edit", "copy"],
            hideBtnOnReadonly: ["edit", "copy", "delete", "more"],
            nameError: false,
            errorMessage: "",
            validateValueId: "",
            validateValueName: "",
            currentSession: false,
            openRenameDialog: false,
            loading: true,
            filter: null,
            selectedInterface: null,
            deleteDocDlg: false,
            currentEntity: null,
            changeHistoryData: [],
            changeHistoryModal: false,
            changeHistoryCurrentPage: 0,
            changeHistoryHasMoreItems: true,
            differentInterface: false,
            importedInterface: false,
            deletedInterface: false,
            openSearch: false,
            isActive: true
        };
    },
    computed: {
        ...mapState("components", ["readOnly", "activeInterface", "appInterfaces"]),
         ...mapGetters("apps", ["currentApp", "getCurrentAppUserPermissions", "processList"]),
        addNewLabel() {
            return this.$t("userInterface.addNewBtn");
        },
        haveEntities() {
            return !!((this.list.uis.length || 0) + (this.list.fragments.length || 0));
        },
        isReadonly() {
            return this.$route.params && this.$route.params.permissions ? this.$route.params.permissions.readonly : false;
        },
        isReadonlyRoom() {
            return !this.$oneAtATime.state.$currentRoomEmpty;
        },
        uiList() {
            return this.filterAndSort(this.list.uis, this.filter);
        },
        fragmentList() {
            return this.filterAndSort(this.list.fragments, this.filter);
        },
        currentList() {
            return (this.selectedTab === "uis") ? this.uiList : this.fragmentList;
        },
        uiCaption() {
            let count, text;

            if (this.selectedTab === "uis") {
                count = this.uiList.length;
                text = this.$tc(`userInterface.${this.filter ? "results" : "interface"}`, count);
            } else {
                count = this.fragmentList.length;
                text = this.$tc(`userInterface.${this.filter ? "results" : "fragment"}`, count);
            }

            return `${count} ${text}`;
        }
    },
    watch: {
        haveEntities: {
            handler(value) {
                if (value) {
                    this.$nextTick(this.addListener);
                }
            },
            immediate: true
        },
        "$backendWebsocketEvents.state.refreshGuiList": function (actionDetails) {
            if (actionDetails) {
                const { id, data } = actionDetails;
                const eventInfo = data.split(":");
                const idInterface = eventInfo[2];
                const actionType = eventInfo[3];
                if (this.currentApp.id === id) {
                    if (actionType === "rename") {
                        const newName = eventInfo[4];
                        this.differentInterface = this.activeInterface !== idInterface;
                        this.refreshAfterRename(newName);
                    } else if (actionType === "persist") {
                        this.refreshAfterSave(idInterface);
                    } else if (actionType === "import") {
                        this.refreshAfterImport(idInterface);
                    } else if (actionType === "delete") {
                        this.differentInterface = this.activeInterface !== idInterface;
                        this.refreshAfterDelete();
                    } else {
                        this.refreshList();
                    }
                }
            }
        },
        selectedTab: {
            handler(newValue) {
                const selectedCurrentTab = newValue === "uis" ? "userInterfaces" : newValue;
                const { path } = this.$route;
                if (!path.includes(selectedCurrentTab)) {
                    this.$router.replace({ path: `/applications/${this.currentApp.id}/${selectedCurrentTab}` }).then(
                        () => {
                            this.$root.$emit("hideSaveBtn", true);
                        }
                    );
                }
            }
        },
        $route: {
            handler(newValue, oldValue) {
                if (newValue.name === "userInterfaces" && !newValue.params.userInterfaceId && oldValue?.params?.userInterfaceId) {
                    this.filter = null;
                    this.refreshInterfaces();
                    this.selectedInterface = null;
                    this.$store.commit("main/setInterfaceDirty", false);
                    this.setActiveInterface();
                    this.selectedTab = "uis";
                    this.$root.$emit("hideSaveBtn", true);
                    if (this.haveEntities) {
                        this.$nextTick(this.addListener);
                    }
                }
            }
        }
    },
    deactivated() {
        if (this.selectedInterface) {            
            this.filter = null;
            this.selectedInterface = null;
            this.setActiveInterface();
            this.selectedTab = "uis";
        }
        this.isActive = false;
        this.$store.commit("rules/setShowRuleTesting", false);
        this.$root.$off("backendWebsocketEvents-publishedApp");
        this.$root.$off("showMoreChangeHistory");
        this.$root.$off("openChangeHistory");
        this.resetState();
        this.resetChangeHistory();
    },
    activated() {
        this.isActive = true;
        this.$root.$emit("setReadonlyTag", this.isReadonly);
        this.selectedInterface = null;
        this.loading = true;
        this.$store.commit("main/setSaveBtnVisible", true);
        this.$root.$emit("showPublish", { noProcesses: this.currentApp.hasOwnProperty("nrOfProcesses")
            ? !this.currentApp.nrOfProcesses : !this.processList.length,
        showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });

        this.getDataModelLatestVersion().then(() => {
            this.refreshInterfaces().then(() => {
                this.loading = false;
                const { query, params } = this.$route;
                if (params.userInterfaceId) {
                    this.selectedInterface = params.userInterfaceId;
                    this.$root.$emit("showCheckedSaveBtn", true);
                } else if (query.search) {
                        this.openSearch = true;
                        this.filter = query.search;
                }
            });
        });
        this.$root.$on("backendWebsocketEvents-publishedApp", data => {
            infoToastPublish(data);
            this.$root.$emit("changePublishError");
        });
        this.$root.$on("showMoreChangeHistory", routeName => {
            if (routeName === this.$route.name) {
                this.changeHistoryCurrentPage += 1;
                this.getChangeHistory();
            }
        });
        this.$root.$on("openChangeHistory", routeName => {
            if (routeName === this.$route.name) {
                this.resetChangeHistory();
                this.getChangeHistory();
            }
        });

        if (this.haveEntities) {
            this.$nextTick(this.addListener);
        }
    },
    created () {
        const { path } = this.$route;
        const selectedCurrentTab = this.selectedTab === "uis" ? "userInterfaces" : this.selectedTab;

        if (!path.includes(selectedCurrentTab)) {
            this.selectedTab = this.selectedTab === "uis" ? "fragments" : "uis";
        }
    },
    mounted() {
        this.$root.$on("oneAtATime-iBuilder-delete", (value, x) => {
            if (value === "true") {
                this.removeInterface(this.currentEntity.id);
                this.deletedInterface = true;
            } else if (value === "false") {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("oneAtATime.uiReadonly")
                });
            }
        });
        this.$root.$on("oneAtATime-iBuilder-rename", value => {
            if (value === "false") {
                setTimeout(() => {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("userInterface.cantBeRenamed", { user: this.$oneAtATime.state.$currentEditingUser })
                    });
                }, 500);
            } else if (value === "true") {
                this.currentSession = true;
                let currentItem = this.currentList.find(elem => elem.id === this.validateValueId);
                if (currentItem) {
                    const payload = {
                        appId: this.currentApp.id,
                        id: this.validateValueId,
                        name: this.validateValueName
                    };
                    this.renameInterface(payload).then((data) => {
                        if (data && data.data.status) {
                            currentItem.name = this.validateValueName;
                            this.checkFreshAppData();
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("userInterface.renamedSuccessfully"),
                                timeout: 2000
                            });
                            this.$oneAtATime.destroyCurrentRoom();
                            this.$store.commit("main/setInterfaceDirty", false);
                            currentItem = null;
                        }
                    });
                }
            }
        });
    },
    beforeDestroy() {
        this.$root.$off("oneAtATime-iBuilder-delete");
        this.$root.$off("oneAtATime-iBuilder-rename");
    },
    methods: {
        ...mapMutations("components", ["addFragment", "setActiveInterface"]),
        ...mapActions("components", ["getDataModelLatestVersion", "importInterface", "exportInterfaceAction", "getLatestAppInterfaces", "guiRemove", "getRawInterfaceModel", "getHistoryData", "recoverInterface", "renameInterface"]),
        ...mapState("main", ["currentApplicationId"]),
        ...mapActions("apps", ["getAppSettingsInfo"]),
        publishAppPermissions,
        showToastUpdate(messageUpdate) {
            this.$toast.showNotify({
                type: "info",
                message: decodeUnicodeEscapes(messageUpdate),
                timeout: 2000
            });
        },
        resetChangeHistory() {
            this.changeHistoryData = [];
            this.changeHistoryCurrentPage = 0;
            this.changeHistoryHasMoreItems = true;
        },
        getChangeHistory() {
            if (this.changeHistoryHasMoreItems) {
                const payload = {
                    searchType: "CHANGE_HISTORY",
                    module: "UIBuilder",
                    applicationId: this.currentApp.id,
                    page: this.changeHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    if(data && data.data && data.data.history) {
                        this.changeHistoryData = this.changeHistoryData.concat(data.data.history);
                        this.changeHistoryHasMoreItems = data.data.hasMorePages;
                    }
                    this.changeHistoryModal = true;
                });
            } else {
                this.changeHistoryModal = true;
            }
        },
        refreshAfterRename(name) {
            if (this.$route.name === "userInterfaces" && !this.currentSession && this.differentInterface) {
                const newNameMsg = `${name} ${this.$t("documents.renamed")} `;
                this.refreshList(newNameMsg);
            }
            this.currentSession = false;
            this.differentInterface = false;
        },
        refreshAfterImport() {
            if (!this.importedInterface && this.$oneAtATime.state.$currentRoomEmpty && !this.activeInterface && !this.currentSession) {
                this.refreshInterfaces().then(() => {
                    if (this.$route.name === "userInterfaces") {
                        const message = this.$t("userInterface.listUpdate");
                        this.showToastUpdate(message);
                    }
                });
            }
            this.currentSession = false;
            this.importedInterface = false;
        },
        refreshList(customMsg) {
            const messageUpdate = customMsg ? customMsg : this.$t("userInterface.listUpdate");
            this.refreshInterfaces().then(() => {
                if (this.$route.name === "userInterfaces" && !this.currentSession) {
                    this.showToastUpdate(messageUpdate);
                }
            });
            this.currentSession = false;
        },
        refreshAfterSave(data) {
            const interfaceExist = data ? this.appInterfaces.find(el => el.id === data) : null;
            if (!interfaceExist && this.$oneAtATime.state.$currentRoomEmpty && !this.activeInterface && !this.currentSession) {
                this.refreshInterfaces().then(() => {
                    if (this.$route.name === "userInterfaces") {
                        const message = this.$t("userInterface.listUpdate");
                        this.showToastUpdate(message);
                    }
                });
            }
            this.currentSession = false;
        },
        refreshAfterDelete() {
            if (!this.deletedInterface && this.differentInterface) {
                this.refreshInterfaces().then(() => {
                    if (this.$route.name === "userInterfaces") {
                        const message = this.$t("userInterface.listUpdate");
                        this.showToastUpdate(message);
                    }
                });
            } else {
                this.refreshInterfaces();
            }
            this.currentSession = false;
            this.deletedInterface = false;
        },
        addListener() {
            const { uploadScreens } = this.$refs;

            if (uploadScreens) {
                uploadScreens.addEventListener("change", this.screensPopoverFileInput);
            }
        },
        resetState() {
            this.filter = null;
            this.selectedTab = "uis";
        },
        filterAndSort(list, filter) {
            const lcFilter = (filter || "").toLocaleLowerCase();
            const newList = filter ? [...list].filter(({ name }) => name.toLocaleLowerCase().includes(lcFilter)) : [...list];

            return newList.sort((a, b) => a.name.localeCompare(b.name));
        },
        async refreshInterfaces() {
            const uis = [];
            const fragments = [];
            const interfaces = await this.getLatestAppInterfaces();

            interfaces.forEach(entry => {
                const { type, id, name } = entry;

                if (type === "GUI") {
                    uis.push({ name, id });
                } else if (type === "FRAGMENT") {
                    fragments.push({ name, id });
                    this.addFragment({ id, data: entry });
                }
            });

            this.list = { uis, fragments };
            return { uis, fragments };
        },
        addNewInterface() {
            if (this.isReadonly) { return; }

            const selectedCurrentTab = this.selectedTab === "uis" ? "userInterfaces" : this.selectedTab;

            this.$store.commit("components/setLegacyRenderer", true);
            this.$router.replace({ path: `/applications/${this.currentApp.id}/${selectedCurrentTab}/createNew` }).then(
                () => {
                    this.selectedInterface = "draft_" + (this.selectedTab === "uis" ? "GUI" : "FRAGMENT");
                    this.$root.$emit("showCheckedSaveBtn", false);
                }
            );
        },
        onClickImportInterface() {
            if (this.isReadonly) { return; }

            this.$store.commit("components/setLegacyRenderer", true);
            this.$refs.uploadScreens.click();
        },
        onDlgOkClick() {
            this.$oneAtATime.createRoom("iBuilder", this.currentEntity.id, "delete");
        },
        openScreen(ev) {
            const selectedCurrentTab = this.selectedTab === "uis" ? "userInterfaces" : this.selectedTab;
            this.$router.replace({ path: `/applications/${this.currentApp.id}/${selectedCurrentTab}/${ev.id}` }).then(
                () => {
                    this.selectedInterface = ev.id;
                    this.$store.commit("main/setInterfaceDirty", false);
                    this.$root.$emit("showCheckedSaveBtn", true);
                }
            );
            // this.$router.push({ name: "userInterfacesLoad", params: { uid: ev.id } });
        },
        actionsList(evt) {
            const { action, item } = evt;
            if (action === "delete") {
                if (this.isReadonly) { return; }
                this.deleteEntry(item);
            } else if (action === "download") {
                this.exportInterface(item);
            }  else if (action === "edit") {
                this.openScreen(item);
            } else if (action === "rename") {
                this.nameError = false;
                this.showEditPopup(item);
            }
        },
        showEditPopup(item) {
            this.validateValueId = item.id;
            this.validateValueName = item.name.trim();
            if (!this.isReadonly) {
                this.openRenameDialog = true;
            }
        },
        validateValue(val) {
            this.validateValueChecks(val);
            if (!this.isReadonlyRoom && !this.nameError && val) {
                this.$oneAtATime.createRoom("iBuilder", this.validateValueId, "rename");
            }
            this.openRenameDialog = this.nameError;
            return !this.nameError;
        },
        validateValueChecks(val) {
            this.nameError = val !== undefined && !val.trim().length;
            this.errorMessage = this.nameError ? this.$t("userInterface.emptyName") : "";
        },
        deleteEntry(entityId) {
            this.currentEntity = entityId;
            this.deleteDocDlg = true;
        },
        removeInterface(guid) {
            if (this.isReadonly) { return; }

            this.guiRemove(guid)
                .then(() => {
                    this.currentSession = true;
                    this.$oneAtATime.destroyCurrentRoom();
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("userInterface.interfaceRemoved"),
                        code: "qfs-removeIOk",
                        timeout: 2000
                    });
                });
        },
        async exportInterface(entry) {
            let fragments;
            const { id: guid, name } = entry;
            const { data } = await this.getRawInterfaceModel({ guid });

            if (data.interfaceJson.config.fragments.length) {
                fragments = `["${data.interfaceJson.config.fragments.join('","')}"]`;
            }

            const exportInterface = { ...data, fragments };
            if (exportInterface) {
                const { data: exportData } = await this.exportInterfaceAction(exportInterface);
                if (exportData) {
                    this.$saveFileAs(`${name || "new_interface"}.json`, JSON.stringify(exportData));
                }
            }
        },
        async screensPopoverFileInput() {
            const files = this.$refs.uploadScreens.files || [];
            if (files.length) {
                const data = await this.$loadFile(files[0]);
                let interfaceData = JSON.parse(updateData(data, this.$generateUID));

                if (!interfaceData.hasOwnProperty("interfaceJson")) {
                    const newInterface = {
                        id: uid(),
                        name: "Interface",
                        code: "INTF_0",
                        description: null,
                        type: "GUI",
                        interfaceJson: interfaceData,
                        fragments: []
                    };
                    const keys = Object.keys(newInterface.interfaceJson.components);
                    keys.forEach(key => {
                        if (newInterface.interfaceJson.components[key].__component === "ctrl-fragment") {
                            delete newInterface.interfaceJson.components[key];
                        }
                    });
                    interfaceData = JSON.parse(JSON.stringify(newInterface));
                }
                const listOfFragments = [...this.appInterfaces];
                const haveInterfaces = this.appInterfaces && this.appInterfaces.length;
                if (interfaceData.type === "GUI" && interfaceData.fragments.length) {
                    interfaceData.fragments.forEach(fragment => {
                        fragment.code = haveInterfaces ? createCode(fragment, listOfFragments) : fragment.code;
                        listOfFragments.push(fragment);
                    });
                    interfaceData.code = haveInterfaces ? createCode(interfaceData, listOfFragments) : interfaceData.code;
                } else {
                    interfaceData.code = haveInterfaces ? createCode(interfaceData, this.appInterfaces) : interfaceData.code;
                }
                this.importedInterface = true;

                this.importInterface(interfaceData).then(() => {
                    this.refreshInterfaces().then(() => {
                        const added = this.appInterfaces.find(entry => entry.code === interfaceData.code);
                        if (added) {
                            this.openScreen(added);
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("userInterface.importInterface"),
                                code: "qfs-removeIOk",
                                timeout: 2000
                            });
                            this.checkFreshAppData();
                        }
                    });
                });
                this.resetFileInput();
            }
        },
        resetFileInput() {
            const { uploadScreens } = this.$refs;
            uploadScreens.type = "";
            this.$nextTick(() => { uploadScreens.type = "file"; });
        },
        checkFreshAppData() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                this.currentApp.publishStatus = data.data.publishStatus;
                this.$store.commit("apps/setCurrentApp", this.currentApp);
            });
        },
        modalAction(evt) {
            if (evt === "close") {
                this.changeHistoryModal = false;
            }
        },
        menuItemChangeHistoryClicked(evt) {
            if (evt.menuOptionClicked === "recover") {
                const payload = {
                    module: "UIBuilder",
                    applicationId: this.currentApp.id,
                    elementId: evt.elementId,
                    commitId: evt.items[0].commitId
                };
                this.recoverInterface(payload).then(response => {
                    if (response && response.data) {
                        if (response.data.isSuccessful === true) {
                            this.changeHistoryModal = false;
                            this.currentSession = true;
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("versioning.interfaceRecovered"),
                                timeout: 2000,
                                hasClose: true
                            });
                            this.checkFreshAppData();
                        } else {
                            const errorCodes = {
                                ALREADY_RECOVERED: this.$t("versioning.interfaceAlreadyRecovered"),
                                MISSING_GUI: this.$t("versioning.interfaceNotFound"),
                                NOT_DELETE: this.$t("versioning.interfaceNotDeleteEvent")
                            };
                            if (errorCodes[response.data.errorCode]) {
                                this.$toast.showNotify({
                                    type: "error",
                                    message: errorCodes[response.data.errorCode],
                                    timeout: 3000,
                                    hasClose: true
                                });
                            }
                        }
                    }
                });
            }
        },
        clearSelectedInterface() {
            this.$router.go(0);
        },
        searchForValue(search) {
            if (this.isActive) {
                const selectedCurrentTab = this.selectedTab === "uis" ? "userInterfaces" : this.selectedTab;
                const query = search ? { search }: {};
                this.$router.replace({ path: `/applications/${this.currentApp.id}/${selectedCurrentTab}`, query });
            }
        }
    }
};
